// Initialize
PJQ.financialMarkups = {
    models: {},
    collections: {},
    views: {}
};

// Models
PJQ.financialMarkups.models.FinancialMarkup = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {

    },
    calculate: function (lineItem, compoundAmt) {
        if (this.get('void') || this.get('isApplied') || this.lineItem != null) {
            return 0;
        }

        let amt;
        if (lineItem instanceof PJQ.models.changeRequests.ChangeRequestLineItem) {
            amt = lineItem.get('revenue') ?? 0;
        } else {
            amt = lineItem.get('amount') ?? 0;
        }

        if (_.size(this.get('costCodeIds')) > 0) {
            if (!_.contains(this.get('costCodeIds'), lineItem.get('costCodeId'))) {
                return 0;
            }
        }

        if (_.size(this.get('costTypeIds')) > 0) {
            if (!_.contains(this.get('costTypeIds'), lineItem.get('costTypeId'))) {
                return 0;
            }
        }

        if (this.get('isCompounding')) {
            amt += compoundAmt ?? 0;
        }

        return PJQ.helpers.mathHelpers.roundAwayFromZero(amt * (this.get('percent') / 10000));
    }
});

// Collections
PJQ.financialMarkups.collections.FinancialMarkups = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.financialMarkups.models.FinancialMarkup,
    endpoint: function () {

    },
    getMarkups: function (lineItems) {
        let result = [],
            sortedMarkups = _.sortBy(_.filter(this.models, (markup) => {
                return !markup.get('delete') && !markup.get('void')
            }), (model) => {
                return model.get('sortOrder');
            });

        let amts = {};
        _.each(lineItems.filter((lineItem) => {
            return !lineItem.get('delete');
        }), (lineItem) => {
            let liMarkup = 0,
                isAppliedLineItem = lineItem.markup != null || lineItem.get('appliedMarkupId') != null;

            _.each(sortedMarkups, (markup) => {
                let amt = amts[markup.cid];
                if (amt == null) {
                    amt = 0;
                }
                let tMarkup = !isAppliedLineItem ? markup.calculate(lineItem, liMarkup) : 0;
                amts[markup.cid] = amt + tMarkup;
                liMarkup += tMarkup;
            });
        });

        _.each(sortedMarkups, (markup) => {
            let amt = amts[markup.cid];
            if (amt == null) {
                amt = 0;
            }
            result.push({
                cid: markup.cid,
                model: markup,
                name: markup.get('name'),
                amount: amt,
                isApplied: markup.get('appliedCostCodeId') != null && markup.get('appliedCostTypeId') != null,
                isVertical: markup.get('isVertical'),
                sortOrder: markup.get('sortOrder')
            });
        });
        return result;
    }
});

// Views
PJQ.financialMarkups.views.FinancialMarkupsList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'financial-markups-list'),
        canEdit: true,
        canVoid: false,
        autoVoid: false
    },
    events: {
        'click .btn-add-markup': 'addMarkup',
        'click .btn-edit-markup': 'editMarkupClicked',
        'click .btn-delete-markup': 'deleteMarkupClicked'
    },
    beforeFirstRender: async function () {
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;
        this.isFetched = false;

        this.subJobs = await this.options.project.fetchSubJobs();
        this.costCodes = await this.options.project.fetchCostCodes();
        this.costTypes = await this.options.project.fetchCostTypes();

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            canEdit: this.options.canEdit
        };
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        let tableData = _.map(this.collection.models, function (markup) {
            if (!markup.get('delete')) {
                return markup;
            }
        }, this)

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.markup-items-table'),
            data: tableData,
            rowId: "cid",
            language: {
                zeroRecords: this.options.canEdit ? 'Click "Add" to create a new Markup Item' : 'No markups have been added'
            },
            paging: false,
            isHideSearch: true,
            onRowDoubleClick: (row) => {
                if (this.options.canEdit) {
                    this.editMarkup(row.data());
                }
            },
            sortableOptions: this.options.canEdit ? {
                data: this.collection,
                stop: (a, b) => {
                    if (this.options.canEdit) {
                        let self = this;
                        self.$('tr').filter('.odd, .even').each(function (index, html) {
                            let row = $(html)[0].id,
                                rowData = self.collection.get(row);
                            rowData.set('sortOrder', index + 1);
                        });
                    }
                }
            } : null,
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: (row) => {
                            this.editMarkup(row.data());
                        },
                        isShown: (row) => {
                            return this.options.canEdit;
                        },
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: (row) => {
                            this.deleteMarkup(row);
                        },
                        isShown: (row) => {
                            return this.options.canEdit;
                        },
                    }
                ]
            },
            order: [0, 'asc'],
            columns: [
                {
                    "data": "attributes.sortOrder",
                    "title": "",
                    "searchable": false,
                    "orderable": false
                },
                {
                    "title": "Name",
                    "data": "attributes.name",
                    "orderable": false,
                    "render": (data, type, row) => {
                        return '<a href="javascript:void(0)" class="btn-edit-markup">' + data + '</a>'
                    }
                },
                {
                    "title": "Percent",
                    "data": "attributes.percent",
                    "orderable": false,
                    "render": (data, type, row) => {
                        return PJQ.helpers.formatHelpers.formatDecimal(data / 100, 2) + "%";
                    }
                },
                {
                    "title": "Compounding",
                    "data": "attributes.isCompounding",
                    "orderable": false,
                    "render": (data, type, row) => {
                        return data ? "Yes" : "No";
                    }
                },
                {
                    "title": "Vertical",
                    "data": "attributes.isVertical",
                    "orderable": false,
                    "render": (data, type, row) => {
                        return data ? "Yes" : "No";
                    }
                },
                {
                    "title": "Changes Only",
                    "data": "attributes.void",
                    "orderable": false,
                    "render": (data, type, row) => {
                        return data ? "Yes" : "No";
                    }
                },
                {
                    "title": "Applies To",
                    "data": "attributes.isApplied",
                    "orderable": false,
                    "render": (data, type, row) => {
                        let appliedCostCodeId = row.get('appliedCostCodeId');
                        if (!(appliedCostCodeId > 0)) {
                            return '';
                        }

                        let costCode = _.find(this.costCodes.models, (costCode) => {
                            return costCode.id === appliedCostCodeId;
                        });
                        return costCode?.getDisplayName() ?? '';
                    }
                },
                {
                    "data": "",
                    "title": "",
                    "visible": this.options.canEdit,
                    "orderable": false,
                    "searchable": false,
                    "canResize": false,
                    "render": () => {
                        if (!this.options.canEdit) {
                            return '';
                        }
                        return '<div class="text-align-right show-on-row-hover" style="width:80px;"><button type="button" class="btn btn-info btn-edit-markup wd-30p mr-1"><i class="fal fa-pencil"></i><button type="button" class="btn btn-danger btn-delete-markup wd-30p"><i class="fal fa-trash-alt"></i></button></button></div>'
                    },
                    "width": '80px'
                }
            ]
        });
    },
    addMarkup: function () {
        let markup = new PJQ.financialMarkups.models.FinancialMarkup({
            name: "",
            percent: 0,
            isCompounding: false,
            isVertical: false,
            sortOrder: this.collection.length + 1,
            costCodeIds: [],
            costTypeIds: [],
            void: this.options.autoVoid === true
        });

        this.editMarkup(markup);
    },
    editMarkupClicked: function (e) {
        let $target = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($target),
            markup = row.data();

        this.editMarkup(markup);
    },
    editMarkup: function (markup) {
        new PJQ.financialMarkups.views.EditFinancialMarkupModal({
            model: markup,
            canEdit: this.options.canEdit,
            canVoid: this.options.canVoid,
            autoVoid: this.options.autoVoid,
            onSave: (markup) => {
                if (markup.isNew() && !markup.hasBeenAdded) {
                    let makeSortable = _.size(_.filter(this.collection.models, (model) => {
                        return !model.get('delete')
                    })) === 0;
                    this.collection.add(markup);
                    this.dataTable.addRow(markup);
                    markup.hasBeenAdded = true;

                    if (makeSortable) {
                        this.dataTable.makeSortable(this.dataTable.options.sortableOptions);
                    }
                } else {
                    this.collection.trigger('update');
                    this.dataTable.refresh();
                }

                if (markup.get('appliedCostCodeId') && markup.get('appliedCostTypeId')) {
                    this.collection.trigger('appliedMarkupChanged', markup);
                }
            }
        });
    },
    deleteMarkupClicked: function (e) {
        let $target = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($target);

        this.deleteMarkup(row);
    },
    deleteMarkup: function (row) {
        let markup = row.data();
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this markup?",
            onDelete: () => {
                markup.set('delete', true);
                this.dataTable.removeRow(row);
                this.collection.trigger('update', markup);
                _.each(this.collection.models, function (markupModel) {
                    if (!markupModel.get('delete') && markupModel.get('sortOrder') > markup.get('sortOrder')) {
                        markupModel.set('sortOrder', markupModel.get('sortOrder') - 1);
                    }
                }, this);

            }
        });
    }
});

PJQ.financialMarkups.views.EditFinancialMarkupModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-edit-financial-markup'),
        maxWidth: 600,
        canVoid: false,
        autoVoid: false
    },
    events: {
        'focus .input-percent': 'selectInput',
        'click .btn-save': 'save',
        'click .applied-markup': 'toggleAppliedMarkup'
    },
    beforeModalCreated: async function () {
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;
        this.isFetched = false;

        this.subJobs = await this.options.project.fetchSubJobs();
        this.costCodes = await this.options.project.fetchCostCodes();
        this.costTypes = await this.options.project.fetchCostTypes();

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            model: this.model,
            canEdit: this.options.canEdit,
            canVoid: this.options.canVoid,
            autoVoid: this.options.autoVoid
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input',
                'textarea'
            ]
        });

        if (_.size(this.model.get('name')) === 0) {
            this.$('.input-name').focus();
        }

        this.costCodePicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-cost-codes'),
            defaultValue: this.model.get('costCodeIds') ? this.model.get('costCodeIds') : [],
            noneSelectedText: _.size(this.costCodes.models) > 0 ? 'Select Cost Codes (Optional)' : 'No Cost Codes exist on this project',
            isDisabled: _.size(this.costCodes.models) === 0,
            isMultiple: true,
            isIntChoices: true,
            isLiveSearch: true,
            onChange: _.bind(function (value) {
                value = _.size(value) > 0 ? value : null;
                this.model.set('costCodeIds', value);
            }, this)
        });
        this.populateCostCodePicker();

        this.costTypePicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-cost-types'),
            isLiveSearch: true,
            isIntChoices: true,
            isDisabled: _.size(this.costTypes.models) === 0,
            noneSelectedText: _.size(this.costCodes.models) > 0 ? 'Select Cost Types (Optional)' : 'No Cost Types exist',
            isMultiple: true,
            choices: _.map(this.costTypes.models, function (costType) {
                return {
                    id: costType.id,
                    name: costType.get('name')
                };
            }),
            defaultValue: this.model.get('costTypeIds') ? this.model.get('costTypeIds') : [],
            onChange: _.bind(function (value) {
                value = _.size(value) > 0 ? value : null;
                this.model.set('costTypeIds', value);
            }, this)
        });

        // Applied Sub Job Picker
        if (_.size(this.subJobs.models) > 0) {
            this.appliedSubJobPicker = new PJQ.inputs.Selectpicker({
                el: this.$('.select-applied-subjob'),
                isLiveSearch: true,
                isIntChoices: true,
                noneSelectedText: "Parent Job",
                choices: _.union([{
                    id: "",
                    name: 'Parent Job'
                }], _.map(this.subJobs.models, function (subJob) {
                    return {
                        id: subJob.id,
                        name: subJob.get('name')
                    };
                })),
                defaultValue: this.model.get('appliedCostCodeId') ? _.find(this.costCodes.models, (costCode) => {
                    return costCode.get('subJobId');
                }) : null,
                onChange: (value) => {
                    this.model.set('appliedCostCodeId', null);
                    this.model.set('appliedCostTypeId', null);

                    let filteredCostCodes = _.filter(this.costCodes.models, (costCode) => {
                        return costCode.get('subJobId') === value;
                    });
                    this.appliedCostCodePicker.updateChoices(_.map(filteredCostCodes, function (costCode) {
                        return {
                            id: costCode.id,
                            name: costCode.get('name')
                        };
                    }));
                    this.appliedCostCodePicker.setValue(null);
                    this.appliedCostTypePicker.setValue(null);
                    this.appliedCostTypePicker.disable();
                }
            });
        } else {
            this.$('.applied-subjob').addClass('hidden');
        }

        // Applied Cost Code Picker
        let filteredAppliedCostCodes = _.filter(this.costCodes.models, (costCode) => {
            let selectedAppliedSubJob = this.appliedSubJobPicker?.getValue() ?? null;
            return selectedAppliedSubJob ? costCode.get('subJobId') === selectedAppliedSubJob.get('id') : costCode.get('subJobId') == null;
        });
        this.appliedCostCodePicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-applied-cost-code'),
            isLiveSearch: true,
            isIntChoices: true,
            choices: _.map(filteredAppliedCostCodes, function (costCode) {
                return {
                    id: costCode.id,
                    name: costCode.getDisplayName()
                };
            }),
            defaultValue: this.model.get('appliedCostCodeId'),
            onChange: (value) => {
                this.model.set('appliedCostCodeId', value);
                this.model.set('appliedCostTypeId', null);

                let costCode = _.find(this.costCodes.models, (costCode) => {
                        return costCode.id === value;
                    }),
                    filteredCostTypes = costCode.get('costTypeIds') != null ? _.filter(this.costTypes.models, (costType) => {
                        return _.contains(costCode.get('costTypeIds'), costType.id);
                    }) : this.costTypes.models;

                this.appliedCostTypePicker.updateChoices(_.map(filteredCostTypes, function (costType) {
                    return {
                        id: costType.id,
                        name: costType.get('name')
                    };
                }));
                this.appliedCostTypePicker.setValue(null);
                this.appliedCostTypePicker.enable();
            }
        });

        // Applied Cost Type Picker
        let appliedCostCode = _.find(this.costCodes.models, (costCode) => {
                return costCode.id === this.model.get('appliedCostCodeId');
            }),
            filteredAppliedCostTypes = appliedCostCode != null && appliedCostCode.get('costTypeIds') != null ? _.filter(this.costTypes.models, (costType) => {
                return _.contains(appliedCostCode.get('costTypeIds'), costType.id);
            }) : this.costTypes.models;
        this.appliedCostTypePicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-applied-cost-type'),
            isLiveSearch: true,
            isIntChoices: true,
            isDisabled: this.model.get('appliedCostCodeId') == null,
            choices: _.map(filteredAppliedCostTypes, function (costType) {
                return {
                    id: costType.id,
                    name: costType.get('name')
                };
            }),
            defaultValue: this.model.get('appliedCostTypeId'),
            onChange: (value) => {
                this.model.set('appliedCostTypeId', value);
            }
        });

        PJQ.helpers.inputHelpers.inputMaskPercent(this.$('.input-percent'), 2, true);
        this.toggleAppliedMarkup();
    },
    selectInput: function (e) {
        let el = $(e.currentTarget)[0];
        if (this.focusInput !== el) {
            this.focusInput = el;
            setTimeout(_.bind(function () {
                this.focusInput.select();
            }, this), 100);
        }
    },
    toggleAppliedMarkup: function () {
        let $checkbox = this.$('.applied-markup'),
            $appliedMarkupContainer = this.$('.applied-markup-container'),
            isChecked = $checkbox.is(':checked'),
            isVerticalCheckbox = this.$('.is-vertical');

        if (isChecked) {

            $appliedMarkupContainer.removeClass('hidden');
            this.model.set('isVertical', false);
            isVerticalCheckbox.prop('checked', false);
            isVerticalCheckbox.prop('disabled', true);
        } else {
            $appliedMarkupContainer.addClass('hidden');
            isVerticalCheckbox.prop('disabled', false);
            this.model.set('appliedCostCodeId', null);
            this.model.set('appliedCostTypeId', null);
            if (this.appliedSubJobPicker) {
                this.appliedSubJobPicker.setValue(null);
            }
            this.appliedCostCodePicker.setValue(null);
            this.appliedCostTypePicker.setValue(null);
        }
    },
    populateCostCodePicker: function () {
        // Group the cost codes by their Sub Job
        let groupedCostCodes = _.groupBy(this.costCodes.models, function (costCode) {
            return costCode.get('subJobId');
        });

        // Convert groupedCostCodes to the format that updateChoices expects
        let choices = _.map(groupedCostCodes, function (costCodes, subJobId) {
            let subJob = _.find(this.subJobs.models, function (subJob) {
                return subJob.id === parseInt(subJobId);
            }, this);
            return {
                name: subJob != null ? subJob.get('name') : 'No Sub Job',
                choices: _.map(costCodes, function (costCode) {
                    return {
                        id: costCode.id,
                        name: costCode.get('name')
                    };
                })
            };
        }, this);

        if (this.costCodePicker != null) {
            this.costCodePicker.updateChoices(choices);
            this.costCodePicker.setValue(this.model.get('costCodeIds') ? this.model.get('costCodeIds') : []);
            if (_.size(this.costCodes.models) > 0 && this.options.canEdit) {
                this.costCodePicker.enable();
            } else {
                this.costCodePicker.disable();
            }
            this.costCodePicker.render();
        }
    },
    validate: function () {
        let isValid = true,
            isAppliedMarkup = this.$('.applied-markup').is(':checked');

        PJQ.helpers.inputHelpers.setInputError(this.$('.input-name'), true);
        if (this.model.get('name') == null || this.model.get('name').trim().length === 0) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.input-name'), false);
            isValid = false;
        }

        PJQ.helpers.inputHelpers.setInputError(this.$('.input-percent'), true);
        if (this.model.get('percent') == null) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.input-percent'), false);
            isValid = false;
        }

        if (isAppliedMarkup) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.select-applied-cost-code'), true);
            if (this.model.get('appliedCostCodeId') == null) {
                PJQ.helpers.inputHelpers.setInputError(this.$('.select-applied-cost-code'), false);
                isValid = false;
            }

            PJQ.helpers.inputHelpers.setInputError(this.$('.select-applied-cost-type'), true);
            if (this.model.get('appliedCostTypeId') == null) {
                PJQ.helpers.inputHelpers.setInputError(this.$('.select-applied-cost-type'), false);
                isValid = false;
            }
        }

        return isValid;
    },
    save: function () {
        if (!this.validate()) {
            return;
        }

        if (typeof this.options.onSave === 'function') {
            this.options.onSave(this.model);
            this.removeModal();
        }
    }
});